import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { useEffect, useReducer, useState } from 'react'
import { showDangerToast } from '../../constants/toaster'
export const AddCountry = (props) => {
  const [isValidFormat, setIsValidFormat] = useState(true)
  const [isCodeRequired, setIsCodeRequired] = useState(false)

  const handleSubmit = () => {
    if (
      props?.countryFormData.name === '' ||
      props?.countryFormData.name === undefined ||
      props?.countryFormData?.code === '' ||
      props?.countryFormData?.code === undefined ||
      props?.countryFormData?.isnCode === '' ||
      props.countryFormData.isnCode === undefined ||
      props.countryFormData.beadsRate === '' ||
      props.countryFormData.beadsRate === undefined ||
      props.countryFormData.bundleGiftServerHost === '' ||
      props.countryFormData.bundleGiftServerHost === undefined ||
      props.countryFormData.bundleGiftServerToken === '' ||
      props.countryFormData.bundleGiftServerToken === undefined ||
      props.countryFormData.currencyCode === '' ||
      props.countryFormData.currencyCode === undefined ||
      props.countryFormData.currencySymbol === '' ||
      props.countryFormData.currencySymbol === undefined ||
      props.countryFormData.currencyName === '' ||
      props.countryFormData.currencyName === undefined
    ) {
      showDangerToast('Please fill all required fields')
    } else {
      props.onSubmit()
    }
  }

  const handleCodeChange = (e) => {
    const inputCode = e.target.value

    // Check if the input starts with a plus sign followed by any number of digits
    const formatValid = /^\+\d*$/.test(inputCode) || inputCode === ''
    setIsValidFormat(formatValid)

    // Check if the input is empty
    const isRequired = inputCode.trim() === ''
    setIsCodeRequired(isRequired)

    // Update the form data regardless of the format

    props.setCountryFormData({
      ...props?.countryFormData,
      code: inputCode
    })
  }
  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header>
        <Modal.Title id='contained-modal-title-vcenter'>
          {props?.countryFormData?.id ? 'Update Country' : 'Add Country'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='row'>
          <div className='col-md-4'>
            <Form.Label className="text-dark font-weight-500 mb-2">Country Name *</Form.Label>
            <Form.Control
              maxLength={15}
              value={props.countryFormData.name}
              onChange={(e) =>
                props.setCountryFormData({
                  ...props?.countryFormData,
                  name: e.target.value
                })
              }
              placeholder='Enter country name'
              aria-label='Country Name'
              aria-describedby='inputGroup-sizing-sm'
            />
            {props?.countryFormData?.name?.trim() === '' ? (
              <label className='custom-error-label'>Name is required*</label>
            ) : (
              <></>
            )}
          </div>
          <div className='col-md-2'>
            <Form.Label className="text-dark font-weight-500 mb-2">ISO Code *</Form.Label>
            <Form.Control
              maxLength={5}
              value={props.countryFormData.isnCode}
              onChange={(e) =>
                props.setCountryFormData({
                  ...props?.countryFormData,
                  isnCode: e.target.value
                })
              }
              placeholder='e.g. US'
              aria-label='ISO Code'
              aria-describedby='inputGroup-sizing-sm'
            />
            {props?.countryFormData?.isnCode?.trim() === '' ? (
              <label className='custom-error-label'>ISO Code is required*</label>
            ) : (
              <></>
            )}
          </div>
          <div className='col-md-3'>
            <Form.Label className="text-dark font-weight-500 mb-2">Phone Code *</Form.Label>
            <Form.Control
              type='text'
              maxLength={5}
              value={props.countryFormData.code}
              onChange={handleCodeChange}
              onBlur={handleCodeChange}
              placeholder='e.g. +1'
              aria-label='Phone Code'
              aria-describedby='inputGroup-sizing-sm'
            />
            {isValidFormat ? (
              <></>
            ) : (
              <label className='custom-error-label'>Invalid code format</label>
            )}
            {props?.countryFormData?.code.trim() === '' && (
              <label className='custom-error-label'>Phone Code is required*</label>
            )}
          </div>
          <div className='col-md-3'>
            <Form.Label className="text-dark font-weight-500 mb-2">Beads Rate *</Form.Label>
            <Form.Control
              type='number'
              step='0.01'
              value={props.countryFormData.beadsRate || ''}
              onChange={(e) =>
                props.setCountryFormData({
                  ...props?.countryFormData,
                  beadsRate: e.target.value
                })
              }
              placeholder='0.00'
              aria-label='Beads Rate'
              aria-describedby='inputGroup-sizing-sm'
            />
            {(props.countryFormData.beadsRate === '' || props.countryFormData.beadsRate === undefined) && (
              <label className='custom-error-label'>Beads Rate is required*</label>
            )}
          </div>
        </div>
        
        <div className='row mt-3'>
          <div className='col-md-4'>
            <Form.Label className="text-dark font-weight-500 mb-2">Currency Code *</Form.Label>
            <Form.Control
              type='text'
              maxLength={3}
              value={props.countryFormData.currencyCode || ''}
              onChange={(e) =>
                props.setCountryFormData({
                  ...props?.countryFormData,
                  currencyCode: e.target.value.toUpperCase()
                })
              }
              placeholder='e.g. USD'
              aria-label='Currency Code'
              aria-describedby='inputGroup-sizing-sm'
            />
            {(props.countryFormData.currencyCode === '' || props.countryFormData.currencyCode === undefined) && (
              <label className='custom-error-label'>Currency Code is required*</label>
            )}
          </div>
          <div className='col-md-2'>
            <Form.Label className="text-dark font-weight-500 mb-2">Currency Symbol *</Form.Label>
            <Form.Control
              type='text'
              maxLength={3}
              value={props.countryFormData.currencySymbol || ''}
              onChange={(e) =>
                props.setCountryFormData({
                  ...props?.countryFormData,
                  currencySymbol: e.target.value
                })
              }
              placeholder='e.g. $'
              aria-label='Currency Symbol'
              aria-describedby='inputGroup-sizing-sm'
            />
            {(props.countryFormData.currencySymbol === '' || props.countryFormData.currencySymbol === undefined) && (
              <label className='custom-error-label'>Currency Symbol is required*</label>
            )}
          </div>
          <div className='col-md-6'>
            <Form.Label className="text-dark font-weight-500 mb-2">Currency Name *</Form.Label>
            <Form.Control
              type='text'
              value={props.countryFormData.currencyName || ''}
              onChange={(e) =>
                props.setCountryFormData({
                  ...props?.countryFormData,
                  currencyName: e.target.value
                })
              }
              placeholder='e.g. US Dollar'
              aria-label='Currency Name'
              aria-describedby='inputGroup-sizing-sm'
            />
            {(props.countryFormData.currencyName === '' || props.countryFormData.currencyName === undefined) && (
              <label className='custom-error-label'>Currency Name is required*</label>
            )}
          </div>
        </div>
        
        <div className='row mt-3'>
          <div className='col-md-4'>
            <Form.Label className="text-dark font-weight-500 mb-2">Bundle Gift Server Host *</Form.Label>
            <Form.Control
              type='text'
              value={props.countryFormData.bundleGiftServerHost || ''}
              onChange={(e) =>
                props.setCountryFormData({
                  ...props?.countryFormData,
                  bundleGiftServerHost: e.target.value
                })
              }
              placeholder='Enter server host'
              aria-label='Bundle Gift Server Host'
              aria-describedby='inputGroup-sizing-sm'
            />
            {(props.countryFormData.bundleGiftServerHost === '' || props.countryFormData.bundleGiftServerHost === undefined) && (
              <label className='custom-error-label'>Bundle Gift Server Host is required*</label>
            )}
          </div>
          <div className='col-md-4'>
            <Form.Label className="text-dark font-weight-500 mb-2">Bundle Gift Server Token *</Form.Label>
            <Form.Control
              type='text'
              value={props.countryFormData.bundleGiftServerToken || ''}
              onChange={(e) =>
                props.setCountryFormData({
                  ...props?.countryFormData,
                  bundleGiftServerToken: e.target.value
                })
              }
              placeholder='Enter server token'
              aria-label='Bundle Gift Server Token'
              aria-describedby='inputGroup-sizing-sm'
            />
            {(props.countryFormData.bundleGiftServerToken === '' || props.countryFormData.bundleGiftServerToken === undefined) && (
              <label className='custom-error-label'>Bundle Gift Server Token is required*</label>
            )}
          </div>
          <div className='col-md-4 d-flex align-items-end'>
            <Form.Check
              type='checkbox'
              label='Bundle Product Based'
              checked={!!props.countryFormData.bundleProductBased}
              onChange={(e) =>
                props.setCountryFormData({
                  ...props?.countryFormData,
                  bundleProductBased: e.target.checked
                })
              }
              className="mt-2"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outlined' onClick={props.onHide}>
          Cancel
        </Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  )
}
